<template>
  <b-container fluid>
    <div class="api-contents">
      <div v-for="(api, index) in apiContents" :key="index" class="api-content">
        <h4 class="api-title">{{ api.language }}</h4>
        <div class="code-content">
          <pre v-highlightjs="api.exampleCode"><code :class="api.languageClass"></code></pre>
          <!-- <pre>
            <code :class="api.languageClass">
              {{ api.exampleCode }}
            </code>
          </pre> -->
        </div>
      </div>
    </div>
  </b-container>
</template>

<script>
import "highlight.js/styles/github.css";

export default {
  data() {
    return {
      apiContents: []
    };
  },

  computed: {
    host() {
      return this.$store.state.host;
    },
    ls_ConverterAPI() {
      return this.$store.state.languagePack.ls_ConverterAPI;
    }
  },

  mounted() {
    this.getSiteAPIs();
  },

  methods: {
    getSiteAPIs() {
      this.$http
        .post(this.host + "/api/qazlatyn/getsiteapis", new FormData())
        .then(result => {
          if (result.status === 200) {
            if (result.body.status === "success") {
              this.apiContents = result.body.data;
            } else {
              // console.log(result.body.message);
            }
          } else {
            // console.log("Err");
          }
        });
    }
  },

  metaInfo() {
    return {
      title: this.ls_ConverterAPI
    };
  }
};
</script>

<style lang="scss" scoped>
.api-contents {
  .api-content {
    margin-bottom: 3rem;

    .api-title {
      font-size: 28px;
      margin-bottom: 20px;
    }

    .code-content {
      margin-top: 0rem;
      border-radius: 0.25rem;
      background: #f7f7f7;
      padding: 0 0.875rem;
      border: 1px solid #e5e6e7
    }
  }
}
.hljs {
  background-color: #ffffff;
}
</style>

<style>
.api-content .code-content * {
  background-color: transparent !important;
}
</style>
